import React from "react";
import { FaIcon } from "./FaIcon";
import { Collapsible } from "./Collapsible";

export const CollaspibleHeader = ({ headerLabel, headerCss, children, ...props }) => {
  const header = (toggleOpen, isOpen) => (
    <h4 className={headerCss} onClick={toggleOpen}>
      {headerLabel}
      <FaIcon icon={"fas float-right " + (isOpen ? "fa-chevron-down" : "fa-chevron-up")} />
    </h4>
  );
  return (
    <Collapsible header={header} {...props}>
      {children}
    </Collapsible>
  );
};
